// Slow editorial marquee separating major sections.
export const EditorialMarquee = ({ items, className = "" }) => {
  const content = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-white/10 py-6 ${className}`}>
      <div className="marquee-track">
        {content.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-display text-3xl md:text-5xl uppercase tracking-tight">
            <span className={i % 2 === 0 ? "text-white" : "text-stroke"}>{item}</span>
            <span className="text-volt text-2xl md:text-3xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
